module.exports = __webpack_public_path__ + "static/sf-skyline-2020-f19f59468c3823a730b2e9cd7aad21ed.svg";